
import _ from 'lodash'

import http from '../../../lib/http'
import { notify } from '../../../lib/Notification/actions.js'

export const ENROLLMENT_SEARCH = 'ENROLLMENT_SEARCH2'
export const ENROLLMENT_FOUND = 'ENROLLMENT_FOUND2'
export const ENROLLMENT_NOT_FOUND = 'ENROLLMENT_NOT_FOUND2'
export const ENROLLMENT_ERROR = 'ENROLLMENT_ERROR2'

export const ENROLLMENT_START = 'ENROLLMENT_START2'
export const ENROLLMENT_STARTED = 'ENROLLMENT_STARTED2'
export const ENROLLMENT_EMAIL_WAS_SENT = 'ENROLLMENT_EMAIL_WAS_SENT2'
export const ENROLLMENT_REVOKED = 'ENROLLMENT_REVOKED2'
export const ENROLLMENT_ACCESS_REVOKED = 'ENROLLMENT_ACCESS_REVOKED2'

export const searchEnrollment = (personId, patientId) => dispatch => {
  dispatch({
    type: ENROLLMENT_SEARCH,
    personId
  })

  if (!patientId) {
    return null
  }

  return http
    .getRequest(`/patients/${patientId}/enrollments/v2?for=${personId}`)
    .then(data => {
      if (data) {
        dispatch({
          type: ENROLLMENT_FOUND,
          enrollment: data,
          personId,
          patientId
        })
      } else {
        dispatch({
          type: ENROLLMENT_NOT_FOUND,
          patientId,
          personId
        })
      }
    })
    .catch(error => {
      dispatch({
        type: ENROLLMENT_ERROR,
        patientId,
        personId,
        error
      })
    })
}

export const startEnrollment =
  (personId, patientId, role, clientName) => dispatch => {
    dispatch({
      type: ENROLLMENT_START,
      personId,
      role
    })

    return http
      .postRequest(`/patients/${patientId}/enrollments/v2`, {
        resourceId: personId,
        role,
        clientName
      })
      .then(response => {
        dispatch({
          type: ENROLLMENT_STARTED,
          personId,
          patientId,
          role
        })

        dispatch(notify(response.display))
        dispatch(searchEnrollment(personId, patientId))
      })
      .catch(e => {
        dispatch(
          notify(
            _.get(e, 'response.data.display', 'Error starting enrollment.'),
            true
          )
        )
      })
  }

export const resendEmail = enrollmentId => dispatch =>
  http
    .postRequest(`/enrollments/v2/${enrollmentId}/resendEmail`, {})
    .then(() => {
      dispatch({
        type: ENROLLMENT_EMAIL_WAS_SENT,
        enrollmentId
      })
      dispatch(notify('Another invitation email has been sent.'))
    })
    .catch(err => {
      const message = _.compact([
        'Error resending invitation.',
        _.get(err, 'response.data.message')
      ]).join(' ')
      dispatch(notify(message, true))
    })

export const revokeEnrollment =
  (enrollmentId, personId, patientId) => dispatch =>
    http
      .postRequest(`/enrollments/v2/${enrollmentId}/revoke`, {})
      .then(() => {
        dispatch({
          type: ENROLLMENT_REVOKED,
          enrollmentId
        })
        dispatch(searchEnrollment(personId, patientId))
        dispatch(notify('Invitation was revoked.'))
      })
      .catch(() => {
        dispatch(notify('Error revoking enrollment.', true))
      })

export const revokeAccess = (personId, patientId, clientName) => dispatch =>
  http
    .postRequest(`/patients/${patientId}/revokeAccess/v2`, {
      for: personId,
      clientName
    })
    .then(() => {
      dispatch({ type: ENROLLMENT_ACCESS_REVOKED })
      dispatch(searchEnrollment(personId, patientId))
      dispatch(notify('Mobile Access has been revoked.'))
    })
    .catch(() => {
      dispatch(notify('Error revoking access.', true))
    })
